export const EXPORT_AGENTS = 'EXPORT_AGENTS';
export const EXPORT_AGENTS_START = 'EXPORT_AGENTS_START';
export const EXPORT_AGENTS_SUCCESS = 'EXPORT_AGENTS_SUCCESS';
export const EXPORT_AGENTS_FAILED = 'EXPORT_AGENTS_FAILED';

export const DOWNLOAD_FILE = 'DOWNLOAD_FILE';
export const DOWNLOAD_FILE_START = 'DOWNLOAD_FILE_START';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAILED = 'DOWNLOAD_FILE_FAILED';
